// src/pages/Travel.js
import React from 'react';
import './Travel.css';
import { Link } from 'react-router-dom';  

function Travel() {
  return (
    <div className="travel">

    <div className="logistics">
    <h1>Travel Information</h1>

    <div className="lodging-details">
      <h2>Lodging</h2>
      <p>We have blocked several rooms at Tru by Hilton Chapel Hill. Please see the information below for more details. </p>
      <p><em>It is important to note that you may be able to find cheaper rates if you have rewards with Hilton or if you book online, as the online algorithm tends to fluctuate a bit more than the fixed rate of a hotel block.</em>  </p>
      <ul>
        <li><b>Group Name:</b> Skidmore & McKenna Wedding</li>
        <li><b>Nightly Rate:</b> $153 + tax</li>
        <li><b>Cut-off date for booking:</b> April 16, 2025</li>
      </ul>
      <p>After April 16th, the hotel will release the rooms to the public and the group rate will no longer be guaranteed.</p>
      <p>You can also book by calling Hilton Reservations at 1-800-HILTONS, and mention <b>Skidmore & McKenna Wedding</b> or the unique code <b>90U</b> to receive the group rate.</p>

      <Link to="https://group.trubyhilton.com/d003gy" target="_blank" rel="noopener noreferrer" className="attraction-button">Book Here</Link>

    </div>

    {/* TRANSPORTATION DETAILS */}
    <div className="transportation-details">
        <h2>Transportation</h2>

          <div className="airports">
            <h3>Airports</h3>
            <p>For guests traveling by plane to join us, please see the following information below:</p>
          
            <img src="./images/attractions/rdu-terminal.webp" alt="rdu airport" className="airport-photo" />
            <h4>Raleigh-Durham International Airport</h4>
              <p>The closest airport to the wedding venue.</p>
              <p>~30 minutes from the wedding venue </p>
              <p>Address: 2400 John Brantley Blvd, Morrisville, NC 27560</p>

          
          <img src="./images/attractions/clt-terminal.webp" alt="clt airport" className="airport-photo" /> 
            <h4>Charlotte-Douglas International Airport</h4>
            <p>Larger airport, but further away.</p>
            <p>~2.5 hours from the wedding venue</p>
            <p>Address: 5501 Josh Birmingham Pkwy, Charlotte, NC 28208</p>
 
         
      </div>
    </div>
    

  

    <div className="attractions">
      <div className="attractions-header">
      <h2>Things to do in the Triangle!</h2>
      <p>There are so many things to do in the Triangle area! Here are a few of our favorites:</p>
      </div>

      <div className="raleigh-city-section">
        <h3>Raleigh</h3>
        <p>Check out these things to do in Raleigh:</p>
        <div className="attraction">
        
          <div className="attraction-info">
            <h4>North Carolina Museum of Art</h4>
            <ul>
              <li>Cost: Free, with priced special exhibits.</li>
              <li>A premier destination for art lovers.</li>
              <li>LALALALA TEST TEXT</li>
            </ul>
            <a href="https://ncartmuseum.org/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/ncma-art-park.webp" alt="North Carolina Museum of Art" className="attraction-photo" />
        </div>
          <div className="attraction-info">
            <h4>North Carolina Farmers Market</h4>
            <ul>
              <li>Cost: Free to enter</li>
              <li>Check out all that farmer NC has to offer.</li>
            </ul>
            <a href="https://ncartmuseum.org/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/nc-farmers-market.webp" alt="North Carolina Museum of Art" className="attraction-photo" />
      

          <div className="attraction-info">
            <h4>North Carolina Museum of History</h4>
            <ul>
              <li>Cost: Free to enter</li>
              <li>A premier destination for art lovers.</li>
            </ul>
            <a href="https://ncartmuseum.org/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/nc-museum-of-history.webp" alt="North Carolina Museum of Art" className="attraction-photo" />

          <div className="attraction-info">
            <h4>Dorothea Dix Park</h4>
            <ul>
              <li>Cost: Free to enter.</li>
              <li>A large, beautiful park in the heart of Raleigh.</li>
            </ul>
            <a href="https://dorotheadixpark.org/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
            </div>
            <img src="./images/attractions/dix-park.webp" alt="Dorothea Dix Park" className="attraction-photo" /> 
          
        {/* Add more attractions for Raleigh */}
      </div>



    {/* DURHAM ATTRACTIONS */}  
      <div className="durham-city-section">
        <h3>Durham</h3>
        <p>Things to do in Durham:</p>
        <div className="attraction">
          <div className="attraction-info">
            <h4>Duke Lemur Center</h4>
            <ul>
              <li>Cost: $12</li>
              <li>Home to the largest population of lemurs outside of Madagascar.</li>
            </ul>
            <a href="https://lemur.duke.edu/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/duke-lemur-center.webp" alt="Duke Lemur Center" className="attraction-photo" />
        </div>
        <div className="attraction">
          <div className="attraction-info">
            <h4>Duke University Chapel</h4>
            <ul>
              <li>Cost: Free to enter, donations encouraged</li>
              <li>Really cool looking church, if you like that sort of thing.</li>
            </ul>
            <a href="https://lemur.duke.edu/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/duke-chapel.webp" alt="Duke Lemur Center" className="attraction-photo" />
        </div>
        <div className="attraction">
          <div className="attraction-info">
            <h4>Duke Gardens</h4>
            <ul>
              <li>Cost: Free to enter, pay to park</li>
              <li>Home to the largest population of lemurs outside of Madagascar.</li>
            </ul>
            <a href="https://lemur.duke.edu/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/duke-gardens.webp" alt="Duke Lemur Center" className="attraction-photo" />
        </div>
        {/* Add more attractions for Durham */}
      </div>


    {/* CHAPEL HILL ATTRACTIONS */} 
      <div className="chapelhill-city-section">
        <h3>Chapel Hill</h3>
        <p>Things to do in Chapel Hill:</p>
        <div className="attraction">
          <div className="attraction-info">
            <h4>North Carolina Botanical Garden</h4>
            <ul>
              <li>Cost: Free to enter</li>
              <li>A beautiful garden showcasing native plants.</li>
            </ul>
            <a href="https://ncbg.unc.edu/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/nc-botanical-gardens.webp" alt="North Carolina Botanical Garden" className="attraction-photo" />
        </div>
        <div className="attraction">
          <div className="attraction-info">
            <h4>Morehead Planetarium</h4>
            <ul>
              <li>Cost: Free to enter</li>
              <li>Family-friendly enjoyment with shows, exhibits, live science demonstrations, special events, giant sundial, gift shop, and more. </li>
            </ul>
            <a href="https://ncbg.unc.edu/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/morehead-planetarium.webp" alt="North Carolina Botanical Garden" className="attraction-photo" />
        </div>
        <div className="attraction">
          <div className="attraction-info">
            <h4>Cat Tales Cat Cafe</h4>
            <ul>
              <li>Cost: Free to enter, purchase items in the cafe</li>
              <li>A lovely place to grab a warm drink and snuggle with kitties up for adoption.</li>
            </ul>
            <a href="https://ncbg.unc.edu/" target="_blank" rel="noopener noreferrer" className="attraction-button">Visit Website</a>
          </div>
          <img src="./images/attractions/cat-tales-cat-cafe.webp" alt="North Carolina Botanical Garden" className="attraction-photo" />
        </div>
        {/* Add more attractions for Chapel Hill */}
      </div>
    </div>
    </div>
  </div>
  );
}

export default Travel;